import React from 'react';
import { IoVideocamOutline } from 'react-icons/io5';
import './LiveStream.css';

function LiveStream() {
  // Extract video ID from the YouTube URL
  const videoId = '-fePqqGqemE';
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className="livestream-page">
      {/* Hero Section */}
      <section className="livestream-hero">
        <div className="livestream-hero-content">
          <div className="livestream-hero-icon">
            <IoVideocamOutline />
          </div>
          <h1>Live Game Show Stream</h1>
          <p className="livestream-hero-sub">
            Watch the live game show stream and follow along with the action in real-time.
          </p>
        </div>
      </section>

      {/* Video Container */}
      <section className="livestream-video-section">
        <div className="livestream-video-container">
          <div className="livestream-video-wrapper">
            <iframe
              className="livestream-iframe"
              src={embedUrl}
              title="Live Game Show Stream"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="livestream-info">
        <div className="livestream-info-card">
          <h2>How to Watch</h2>
          <p>
            The live stream is embedded above. You can watch it on any device - desktop, laptop, tablet, or mobile phone.
            The video player will automatically adjust to your screen size for the best viewing experience.
          </p>
          <p>
            <strong>Tip:</strong> Look for the "Watch Stream" button that appears on any page. Click it to open a 
            persistent video player that stays visible while you navigate to answer questions or browse other pages. 
            You can minimize it, move it to different corners, and it will remember your preferences!
          </p>
          <p>
            Make sure you're logged in to participate in the game show questions while watching the stream!
          </p>
        </div>
      </section>
    </div>
  );
}

export default LiveStream;

